<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <DateModal
        modalID="delivered_equipment_column"
        :fetchData="fetchData"
        :dateFrom="dateFrom"
        :dateTo="dateTo"
        @date-picker-modal-emit="onDatePickerModalEmit"
      ></DateModal>

      <b-card class="backClass" header="Received">
        <div
          slot="header"
          style="display:flex; justify-content: space-between;"
        >
          <HeaderTitle
            title="Delivered Equipment"
            :dateFrom="
              from(dateFrom)
                ? $formatUSDate(from(dateFrom))
                : $formatUSDate(dateFrom)
            "
            :dateTo="
              to(dateTo) ? $formatUSDate(to(dateTo)) : $formatUSDate(dateTo)
            "
            productGroups="true"
            productGroupsEmit="showDeliveredDetails"
            @showDeliveredDetails="detailView"
          ></HeaderTitle>
          <HeaderControl
            :showFullscreenIcon="true"
            :showDateIcon="true"
            :showDownloadPdfIcon="true"
            :showDownloadExcelIcon="true"
            @emit-fullscreen="toggleFullScreen"
            @emit-date="modalDateEvent"
            @emit-pdf-download="downloadPDF"
            @emit-excel-download="
              downloadExcel(
                $http,
                { date_from: from(dateFrom), date_to: to(dateTo) },
                setLoading,
                'api/tables/downloadEntireDeliveredEquipment.php',
                'DeliveredReport'
              )
            "
            :loadingExcel="loadingExcel"
            :loadingPdf="loadingPdf"
          ></HeaderControl>
        </div>
        <div style="width: 100%; display: flex; justify-content: flex-end;">
          <h5>Quantity</h5>
        </div>
        <div class="chart-wrapper">
          <LoadingCard v-if="loadingData"></LoadingCard>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <FooterOptions
          :showTop10="true"
          :showAll="true"
          :showOverall="true"
          :overallUrl="
            isCelia
              ? '/base/TableAllDataC?type=Shipped&date_from=' +
                (from(dateFrom) ? from(dateFrom) : dateFrom) +
                '&date_to=' +
                (to(dateTo) ? to(dateTo) : dateTo)
              : '/base/TableAllDataPaginated?type=Shipped&date_from=' +
                (from(dateFrom) ? from(dateFrom) : dateFrom) +
                '&date_to=' +
                (to(dateTo) ? to(dateTo) : dateTo) +
                '&client_location=All'
          "
          @top-10-all-data-emit="top10AllDataEmit"
        ></FooterOptions>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../../router";
import Datepicker from "vuejs-datepicker";
import { Switch as cSwitch } from "@coreui/vue";
import DateModal from "../../shared/DateModal.vue";
import HeaderTitle from "../../shared/HeaderTitle.vue";
import HeaderControl from "../../shared/HeaderControl.vue";
import FooterOptions from "../../shared/FooterOptions.vue";
import LoadingCard from "../../shared/LoadingCard.vue";
import { DeliveredEquipmentColumnChart } from "../../../utils/ChartProps";
import {
  from,
  isCurrentUser,
  isUserLoggedIn,
  to,
  downloadExcel
} from "../../../utils/Utils";
import Constants from "../../../utils/Constants";

export default {
  name: "DeliveredEquipmentColumn",
  components: {
    router,
    highcharts: Chart,
    Datepicker,
    cSwitch,
    DateModal,
    HeaderTitle,
    HeaderControl,
    FooterOptions,
    LoadingCard
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity"],
  data: function() {
    return {
      from: from,
      to: to,
      downloadExcel: downloadExcel,
      fullscreen: false,
      loadingData: false,
      loadingExcel: false,
      loadingPdf: false,
      showAll: false,
      modalDate: false,
      valueQuantity: false,
      isCelia: false,
      dateName: "",
      dateFrom: "",
      dateTo: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      chartOptions: {}
    };
  },
  watch: {
    dateFrom() {
      this.chartOptions = DeliveredEquipmentColumnChart(
        router,
        this.from(this.dateFrom),
        this.to(this.dateTo),
        this.locationsIds
      );
    },
    dateTo() {
      this.chartOptions = DeliveredEquipmentColumnChart(
        router,
        this.from(this.dateFrom),
        this.to(this.dateTo),
        this.locationsIds
      );
    },
    valueQuantity() {
      this.fetchData();
      if (this.fullScreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
    }
  },
  methods: {
    top10AllDataEmit(disabledAll) {
      this.showAll = disabledAll;
      this.fetchData();
    },
    detailView() {
      this.$emit("detailViewShip");
    },
    modalDateEvent() {
      this.exitFullscreen();
      this.$bvModal.show("delivered_equipment_column");
    },
    exitFullscreen() {
      if (!this.fullscreen) {
        return;
      } else {
        this.toggleFullScreen();
      }
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      let finType = "Qty";
      params = {
        type: finType,
        date_from: this.dateFrom,
        date_to: this.dateTo,
        chartType: "Shipped"
      };
      this.$http.get("api/charts/chart_data.php", { params }).then(
        res => {
          const uom = finType == "Fin" ? ": $" : " units: ";
          this.chartOptions.title.text = `Total${uom}${res.data.totals}`;
          if (res.data.totals === 0) {
            this.loadingData = false;
            this.chartOptions.series[0].data = [];
            this.chartOptions.drilldown.series = [];
            return true;
          }

          this.locationName = res.data.dnData[0].name;
          if (!this.showAll) {
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1
            );

            let smp = res.data.dnData;

            smp.forEach(value => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });

            let newArr = tmp.slice(0, 10);
            if (this.locParam == 0) {
              if (smp.length != 0) {
                this.chartOptions.series[0].data = smp[0].data;
              }
            } else {
              this.chartOptions.series[0].data = newArr;
              this.chartOptions.drilldown.series = smp;
            }
          } else {
            let smp = res.data.dnData;

            smp.forEach(value => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1
            );
            this.chartOptions.series[0].data = tmp;
            this.chartOptions.drilldown.series = smp;
          }

          //  // Getting total amount wihtout response
          // var seriesData = this.chartOptions.series;
          // var pointSum = 0;
          // seriesData.forEach(function(point) {
          //   var datasValue = point.data;
          //   datasValue.forEach(function(value) {
          //     pointSum += parseInt(value.locationTotal);
          //   })
          // });
          this.chartOptions.title.text = "Total units: " + res.data.totals;
          
          this.loadingData = false;
          setTimeout(() => {
            this.changeHeight();
          });
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    downloadPDF() {
      this.loadingPdf = true;
      if (this.locParam == 1) {
        this.$refs.backRef.chart.options.title.text =
          "Delivered equipment | " +
          (this.from(this.dateFrom)
            ? this.from(this.dateFrom)
            : this.dateFrom) +
          " - " +
          (this.to(this.dateTo) ? this.to(this.dateTo) : this.dateTo) +
          " " +
          this.locationName;
        this.$refs.backRef.chart.options.title.style.color = "black";
      } else {
        this.$refs.backRef.chart.options.title.text =
          "Delivered equipment | " + this.from(this.dateFrom)
            ? this.from(this.dateFrom)
            : this.dateFrom + " - " + this.to(this.dateTo)
            ? this.to(this.dateTo)
            : this.dateTo + " " + this.nameCity;
        this.$refs.backRef.chart.options.title.style.color = "black";
      }

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename:
          "DeliveredEquipment-" +
          (this.from(this.dateFrom)
            ? this.from(this.dateFrom)
            : this.dateFrom) +
          "-" +
          (this.to(this.dateTo) ? this.to(this.dateTo) : this.dateTo)
      });
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
      this.loadingPdf = false;
    },
    setLoading(loading) {
      this.loadingExcel = loading;
    }
  },
  mounted() {
    isUserLoggedIn(router);
    this.isCelia = isCurrentUser(Constants.CELIA, Constants.REACHEL);
    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
    }
    this.valueQuantity = false;
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.chartOptions = DeliveredEquipmentColumnChart(
      router,
      this.from(this.dateFrom),
      this.to(this.dateTo),
      this.locationsIds
    );
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.small {
  float: right !important;
}
.highcharts-exporting-group {
  display: none !important;
}
</style>
